const { NODE_ENV } = process.env
const IS_LOCAL_DEV = NODE_ENV === 'development'
// @ts-ignore
const env = MULTIPOLAR_ENV
const {
  BUILD_ENV = 'alpha',
  VERSION,
  AUTH_KEY,
  AUTH_TOKEN,
  FIREBASE_AUDIENCE = 'local',
  GA_ID,
  SERVER_API_URL,
} = env

export {
  IS_LOCAL_DEV,
  BUILD_ENV,
  VERSION,
  AUTH_KEY,
  AUTH_TOKEN,
  FIREBASE_AUDIENCE,
  GA_ID,
  SERVER_API_URL,
}
